import classNames from 'classnames';
import i18n from '@/settings/i18n';
import Loading from '@/components/Loading/Loading';
import { useCartContext } from '@/utils/hooks/cart/useCartContext';
import { AddToCartButtonProps } from './hooks/types';

const t = i18n.init('product');

const AddToCartButton = ({
  testingId,
  vendorOfferId,
  vendorSku,
  psku,
  className,
  fullHeight = false,
  id,
  label,
  disabled = false,
  onClick,
  isOutOfStock,
}: AddToCartButtonProps) => {
  const { cartLoading } = useCartContext();

  const isDisabled = disabled || cartLoading;
  const isLoading = cartLoading;

  const _label = (() => {
    if (isOutOfStock) {
      return t`Out of Stock`;
    }

    if (isLoading) {
      return <Loading />;
    }

    return label ?? t`Add to Cart`;
  })();

  return (
    <div id={id} className={classNames(className, { 'h-full': fullHeight })}>
      <button
        id={testingId}
        data-vendor-offer-id={vendorOfferId}
        data-vendor-sku={vendorSku}
        data-psku={psku}
        className={classNames(
          'w-full rounded-md bg-gray-700 px-5 text-sm font-bold text-white  transition duration-150 ease-in-out focus:outline-none disabled:cursor-not-allowed disabled:opacity-60',
          {
            'hover:bg-gray-700/90 hover:shadow-lg': !isDisabled,
            'h-full min-h-[55px]': fullHeight,
            'h-[55px]': !fullHeight,
          },
        )}
        onClick={onClick}
        disabled={isDisabled}
      >
        {_label}
      </button>
    </div>
  );
};

export default AddToCartButton;
